import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { SUPPORT_EMAIL } from "@/lib/brand";

const topics = [
  ["About an order", "Include your order ID and the email you used at checkout. If something arrived damaged, add photos and a short description."],
  ["Before you order", "Have a date in mind, or a question about delivery, changes or returns? Write to us before you order and we’ll reply personally."],
  ["Your memories and privacy", "To see, correct or delete your information, write to the same address. Please don’t email card details or sensitive documents."],
];
export default function ContactPage() {
  return <><SiteHeader/><main id="main-content" className="brand-container brand-section contact-grid">
    <div>
      <h1 className="display-title" data-testid="contact-heading">Let’s <em>talk.</em></h1>
      <p className="lede mt-6">A gifting date in mind? A question about your book? Write to us.</p>
      <a className="text-link mt-6 break-all" href={`mailto:${SUPPORT_EMAIL}`} data-testid="contact-email">{SUPPORT_EMAIL}<ArrowUpRight size={16}/></a>
    </div>
    <div className="contact-topics">
      {topics.map(([title, body]) => <section key={title}><h2 className="display-m">{title}</h2><p className="section-copy mt-2">{body}</p></section>)}
      <Link to="/privacy" className="text-link" data-testid="contact-privacy">Read our Privacy Policy <ArrowUpRight size={15}/></Link>
    </div>
  </main><SiteFooter/></>;
}
